module.exports = __webpack_public_path__ + "img/thumbnail_WesternLowlandGorilla_j_albino.6ac2b94f.png";